/* global newrelic */
import SumoLogger from "sumo-logger";
import { v4 } from "uuid";
import Cookies from "js-cookie";

export const MOBILE_DEBUG_COOKIE_NAME = "mobileDebugOn";

export const mobileDebugOn = () => Cookies.get(MOBILE_DEBUG_COOKIE_NAME);

export const newRelic = (msg, err) => {
  if (typeof newrelic === "undefined") return;
  newrelic.noticeError(new Error(msg), err);
};

const DEFAULT_STYLE_LOGS = {
  margin: "0",
  "z-index": 999999,
  width: "100%",
  position: "relative",
  background: "white",
};

export class Logger {
  constructor() {
    if (!process.env.SUMOLOGGER_ENDPOINT) return null;

    const opts = {
      endpoint: process.env.SUMOLOGGER_ENDPOINT,
      sessionKey: v4(),
      returnPromise: false,
      interval: 20000, // Send messages in batches every 20 seconds
      batchSize: 100000, // Or when total log length reaches 100k charact
      sourceName: "JibJab ReactJS",
      sourceCategory: "jibjab_react_js",
      hostName: process.env.DEPLOY_ENV,
    };

    this.sumoLogger = new SumoLogger(opts);
  }

  addTrackingInfo = (message) => {
    let trackingInfo = this.getBrowserInfo();
    const userInfo = this.getUserInfo();

    if (userInfo) {
      trackingInfo = `${trackingInfo} | ${userInfo}`;
    }

    return `${trackingInfo} | ${message} | ${process.env.GIT_BRANCH}`;
  };

  getBrowserInfo = () => {
    const cookieName = "sumo_logger_browser_id";
    let browserId = Cookies.get(cookieName);

    if (!browserId) {
      browserId = v4();
      Cookies.set(cookieName, browserId, { expires: 1825 });
    }

    return `Browser ID: ${browserId}`;
  };

  getUserInfo = () => {
    if (!window.currentUser) return null;

    const userId = `User ID: ${window.currentUser.id}`;
    const isAnon = `isAnonymousUser: ${window.currentUser.role === "anonymous"}`;

    return `${userId} | ${isAnon}`;
  };

  log(message, options) {
    const defaults = {
      url: window.location.href,
    };

    if (!this.sumoLogger) {
      console.error(
        `No SumoLogger endpoint was provided - error msg intended to log: ${this.addTrackingInfo(message)}`,
      );

      return;
    }

    console.error(message);
    this.sumoLogger.log(this.addTrackingInfo(message), { ...defaults, ...options });

    if (mobileDebugOn()) {
      const elem = document.createElement("p");
      Object.keys(DEFAULT_STYLE_LOGS).forEach((property) => {
        if (property != null) elem.style[property] = DEFAULT_STYLE_LOGS[property];
      });
      elem.innerHTML = message;
      document.body.appendChild(elem);
    }
  }

  logError(message) {
    this.log(message);
    newRelic(message);
  }

  flushLogs() {
    if (!this.sumoLogger) return;

    this.sumoLogger.flushLogs();
  }

  logDebug = (msg) => {
    console.debug(msg);

    if (mobileDebugOn()) {
      const elem = document.createElement("p");
      Object.keys(DEFAULT_STYLE_LOGS).forEach((property) => {
        if (property != null) elem.style[property] = DEFAULT_STYLE_LOGS[property];
      });
      elem.innerHTML = msg;
      document.body.appendChild(elem);
    }
  };
}

export const jjLogger = new Logger();
